/**
 * GenerateShareUrlController
 *
 * @author Felix König <felix.koenig@pluswerk.ag>
 */
Pluswerk.PlusProject.Utility.GenerateShareUrlController = function () {
  var $shareLinkElements = $('.js-share-absolute-url');
  $shareLinkElements.each(function () {
    var $this = $(this);
    var shareUrl = $this.attr('href');
    shareUrl = shareUrl.replace('###absolute-url###', window.location.href);
    $this.attr('href', shareUrl);
  });
};
